import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0667df24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-mr-3 p-ml-3 p-my-2 p-text-right f-size-14 textc-primary" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"120px"} }, null, -1))
const _hoisted_3 = { class: "p-p-3 shadow fixed-bottom bg-white" }
const _hoisted_4 = { class: "p-d-flex p-jc-between p-pb-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ราคาสุทธิ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaymentBankAccount = _resolveComponent("PaymentBankAccount")!
  const _component_PaymentSlipForm = _resolveComponent("PaymentSlipForm")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("u", {
        class: "pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onSetIsSelectedPaymentMethod')))
      }, "เปลี่ยนช่องทางการชำระเงิน")
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_PaymentBankAccount)
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_PaymentSlipForm, {
        transferSlip: _ctx.transferSlip,
        imageList: _ctx.imageList,
        listImage: _ctx.listImage,
        uploadSlipMessage: _ctx.uploadSlipMessage,
        onOnDeleteImageItem: _ctx.onDeleteImageItem,
        onSetImageIndex: _ctx.setImageIndex,
        onOnFileChange: _ctx.onFileChange,
        onOnHandleIsSelectedPaymentMethod: _ctx.onHandleIsSelectedPaymentMethod
      }, null, 8, ["transferSlip", "imageList", "listImage", "uploadSlipMessage", "onOnDeleteImageItem", "onSetImageIndex", "onOnFileChange", "onOnHandleIsSelectedPaymentMethod"])
    ]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", null, _toDisplayString(_ctx.$filters.formatNumber(_ctx.transaction.grandTotal)), 1)
      ]),
      _createVNode(_component_Button, {
        class: "bg-black w-100",
        label: "ชำระเงิน",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSubmit()))
      })
    ])
  ]))
}